const Header = () => (
    <header className="w-1/2 mx-auto flex flex-1 justify-around">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/0/01/Ethereum_logo_translucent.svg"
          alt=""
          className="App-logo"
          title="Ethereum"
        />
    </header>
)

export default Header;
